/**
 * FeaturedCollectionCard - featured collection tile card.
 * Custom element: <featured-collection-card>
 *
 * Loading: lazy-loaded by the theme loader (theme.js), which imports this
 * file by its exact name - the filename is load-bearing (import map in
 * snippets/theme-head.liquid).
 * Reconstructed to readable identifiers from the original minified vendor
 * bundle; behaviour verified unchanged by AST alpha-equivalence.
 */
var defineProperty = Object.defineProperty;
var setFunctionName = (target, functionName) => defineProperty(target, "name", {
  value: functionName,
  configurable: !0
});
import { ThemeComponent } from "./theme.js";
import "./vendor.js";
class FeaturedCollectionCard extends ThemeComponent {}
setFunctionName(FeaturedCollectionCard, "FeaturedCollectionCard");
const propertyTypes = {};
FeaturedCollectionCard.prototype.$name = "FeaturedCollectionCard";
FeaturedCollectionCard.prototype.$info = JSON.parse('{"name":"FeaturedCollectionCard","meta":{"isLegacy":false,"selector":"featured-collection-card"},"props":[],"refs":[]}');
FeaturedCollectionCard.prototype.$info.component = FeaturedCollectionCard;
for (const prop of FeaturedCollectionCard.prototype.$info.props) prop.propertyType = propertyTypes[prop.propertyType];
window.componentService.registerComponent("FeaturedCollectionCard/FeaturedCollectionCard.ts", {
  FeaturedCollectionCard: FeaturedCollectionCard
}, void 0);